import { FormattedMessage } from 'react-intl';
import {
  Box,
  Dialog,
  AnchorButton,
  Text,
  CheckboxStateless,
  Loading,
  Alert
} from '../../components';
import { BlockContent } from '../../components/BlockContent';
import { useSanityTermsOfPurchase } from '../../lib/sanity/useSanityTermsOfPurchase';
import { globalMessages } from '../../lib/messages';

export const TermsOfSale = ({
  checked,
  onChange
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => {
  const { data, loading, error } = useSanityTermsOfPurchase();

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return (
      <Alert variant="error">
        <FormattedMessage {...globalMessages.genericError} />
      </Alert>
    );
  }

  if (!data) {
    return null;
  }
  const heading = data.heading || data.title;
  const { intro, content } = data;
  return (
    <Box mb={6}>
      <Text small>
        <CheckboxStateless
          data-testid="terms-checkbox"
          value="termsChecked"
          label={
            <span>
              <Box as="span" mr={1}>
                <Dialog
                  heading={heading || undefined}
                  renderOpenButton={openPortal => (
                    <FormattedMessage
                      id="valueCodes.accept_terms_of_purchase_checbkox"
                      defaultMessage="I accept the <link>terms of purchase</link> and cannot undo this purchase"
                      values={{
                        link: function OpenPortal(...chunks) {
                          return (
                            <AnchorButton onClick={openPortal} color="primary">
                              {chunks}
                            </AnchorButton>
                          );
                        }
                      }}
                    />
                  )}
                >
                  {intro && <BlockContent blocks={intro} />}
                  {content && <BlockContent blocks={content} />}
                </Dialog>
              </Box>
            </span>
          }
          checked={checked}
          onChange={event => {
            onChange(event.target.checked);
          }}
        />
      </Text>
    </Box>
  );
};
